export default __webpack_public_path__ + "static/media/logo.bb143445.svg";